import { RudderAnalytics } from "@rudderstack/analytics-js";
import { enrichExtraWithCohort } from "@mindstonehq/ui";
import { WebConfig } from "~/hooks/webconfig";

let rudderAnalytics: RudderAnalytics | null = null;

function init(webConfig: WebConfig) {
  rudderAnalytics = new RudderAnalytics();
  rudderAnalytics.load(
    webConfig.rudderstackWriteKeyWebApp,
    webConfig.rudderstackURL,
    {},
  );
}

async function track(
  event: string,
  extra: { [key: string]: any } = {},
  cb?: () => void,
) {
  if (typeof window == "undefined") return;
  if (!rudderAnalytics) rudderAnalytics = new RudderAnalytics();

  extra["application"] = "web";
  extra["application_version"] = webConfig.revision;
  const enriched = await enrichExtraWithCohort(extra);
  rudderanalytics.track(event, enriched, cb);
}

async function pageView(name: string, extra: { [key: string]: any } = {}) {
  if (typeof window == "undefined") return;
  if (!rudderAnalytics) rudderAnalytics = new RudderAnalytics();

  extra["application"] = "web";
  extra["application_version"] = webConfig.revision;
  const enriched = await enrichExtraWithCohort(extra);
  rudderanalytics.page(name, enriched);
}
function getUserID(): string {
  if (typeof window == "undefined") return "";
  if (!rudderAnalytics) rudderAnalytics = new RudderAnalytics();
  return rudderanalytics.getAnonymousId();
}

function experimentStart(name: string, variantID: number, variantName: string) {
  track("experiment_viewed", {
    experiment_name: name,
    experiment_variant: variantName,
    experiment_variant_id: variantID,
  });
}

function addEmail(
  userID: string,
  email: string,
  hasProgram = false,
  hasSubscription = false,
) {
  if (typeof window == "undefined") return;
  if (!userID || !email) {
    return;
  }
  if (!rudderAnalytics) rudderAnalytics = new RudderAnalytics();

  console.log(
    "identify",
    userID,
    "hasProgram",
    hasProgram,
    "hasSubscription",
    hasSubscription,
  );

  return rudderanalytics.identify(
    userID,
    { email, has_program: hasProgram, has_subscription: hasSubscription },
    {},
    () => {},
  );
}

function updateLevel(userID: string, level: number) {
  if (typeof window == "undefined") return;
  if (!rudderAnalytics) rudderAnalytics = new RudderAnalytics();
  return rudderanalytics.identify(
    userID,
    { prompt_level: level },
    {},
    () => {},
  );
}

function reset() {
  if (typeof window == "undefined") return;
  if (!rudderAnalytics) rudderAnalytics = new RudderAnalytics();
  return rudderanalytics.reset(true);
}

const metrics = {
  pageView,
  track,
  getUserID,
  experimentStart,
  addEmail,
  updateLevel,
  reset,
  init,
};
export default metrics;
